import { Routes, Route } from 'react-router-dom';
import { inject } from '@vercel/analytics';

// Persona Version (Main)
import PersonaApp from './persona/PersonaApp';

// Legacy Version (v1) 
import HomeV1 from './v1/pages/Home';
import ArchiveV1 from './v1/pages/Archive';
import ShowcaseV1 from './v1/pages/Showcase';

// Shared Components
import NoPage from './v1/pages/NoPage';

function App() {
  inject();

  return (
    <Routes>
      <Route path="v1">
        <Route index element={<HomeV1 title="Jerel Layog | Classic" />} />
        <Route path="archive" element={<ArchiveV1 title="Archive | Classic" />} />
        <Route path="showcase/:slug" element={<ShowcaseV1 />} />
      </Route>

      <Route path="/" element={<PersonaApp />} />
      <Route path="/projects" element={<PersonaApp />} />
      <Route path="/projects/:slug" element={<PersonaApp />} />
      <Route path="/archive" element={<PersonaApp />} />
      <Route path="/career" element={<PersonaApp />} />
      <Route path="/skills" element={<PersonaApp />} />
      <Route path="/contact" element={<PersonaApp />} />

      <Route path="*" element={<NoPage title="404!" />} />
    </Routes>
  );
}

export default App;